var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"print-color subtitle-border mb-2"},[_vm._v(_vm._s(_vm.$t('findings'))+"：")]),(_vm.findings.length)?_c('ol',_vm._l((_vm.findings),function(finding){return _c('li',{key:finding.id,staticClass:"mb-2"},[_c('FindingItemContent',{attrs:{"finding":finding}})],1)}),0):_c('p',{staticClass:"pl-3"},[_vm._v("Nil")])])
}
var staticRenderFns = []

export { render, staticRenderFns }